module.exports = __webpack_public_path__ + "static/img/shield-lock.7e3758b6.svg";